// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_idC","cls2":"Comments-cls2_GCT Comments-cls1_idC"};